<div class="flex h-full flex-col items-center justify-center">
  <h1 class="mb-14 text-center text-h1 font-semibold text-text-primary">
    {{ 'waitlist_blocker_title' | translate }}
  </h1>
  <h4 class="typo-h4-thin mb-14 max-w-[440px] whitespace-pre-wrap text-center text-text-primary">
    {{ 'waitlist_blocker_description' | translate }}
  </h4>
  <button class="btn-primary mb-3 h-10 px-20" type="button" (click)="onGoToShowCase()">
    {{ 'waitlist_blocker_button' | translate }}
  </button>
</div>
